import http from "../httpService";
import {getBaseUrl} from "../../config";

;


export const getRole = id => {
  return http.get(
    `${getBaseUrl()}/role/${id}`
  );
};

export const getRoles = () => {
  return http.get(
    `${getBaseUrl()}/role`
  );
};

export const getUsersNameAndRole = () => {
  return http.get(
    `${getBaseUrl()}/users_name_role`
  );
};

export const updateRole = data => {
  return http.put(
    `${getBaseUrl()}/role/${data.id}`,
    data
  );
};
export const submitRole = data => {
  return http.post(
    `${getBaseUrl()}/role`,
    data
  );
};
